import React from "react";
import { useSnapshot } from "valtio";

import {
    computedStore,
    designStore,
    setPageInformationMessageItems,
    setInformationMessageItems,
} from "@store";

import { CustomInput as Input } from "@components/Common/CustomInput";

export function InformationMessageRow(): JSX.Element {
    const {
        selectedLanguage,
        informationMessageItems,
        activeSlideIndex,
    } = useSnapshot(designStore);

    const { elements } = useSnapshot(computedStore);

    function handleInformationMessageItemInputOnChangeEvent(content: string) {
        const localItems: HeaderLanguageItemsType = {
            ...informationMessageItems,
            [selectedLanguage]: {
                defaultContent:
                    informationMessageItems[selectedLanguage].defaultContent,
                content: content,
            },
        };
        setInformationMessageItems(localItems);
        setPageInformationMessageItems(
            localItems,
            elements[activeSlideIndex].name
        );
    }

    return (
        <tr>
            <td style={{ width: "30%" }}>
                {informationMessageItems[selectedLanguage].defaultContent !==
                undefined
                    ? informationMessageItems[selectedLanguage].defaultContent
                    : null}
            </td>
            <td>
                <Input
                    value={
                        informationMessageItems[selectedLanguage].content !==
                        undefined
                            ? informationMessageItems[selectedLanguage].content
                            : undefined
                    }
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        return handleInformationMessageItemInputOnChangeEvent(
                            event.target.value
                        );
                    }}
                />
            </td>
        </tr>
    );
}
